const cardsData = [
  {
    title: '91免费看片 V8.2 安卓版',
    desc: '最新安卓客户端，支持全格式解码与手势控制，安装包仅28MB，启动快、播放稳。',
    img: 'https://readdy.ai/api/search-image?query=A%20modern%20Android%20smartphone%20displaying%20a%20video%20streaming%20app%20homepage%20with%20colorful%20movie%20posters%20in%20grid%20layout%2C%20clean%20white%20background%2C%20minimal%20flat%20lay%20product%20photography%2C%20soft%20warm%20lighting%2C%20professional%20app%20showcase%20style&width=800&height=500&seq=card-android-01&orientation=landscape',
    tag: '安卓专属',
  },
  {
    title: '91免费看片 iOS 客户端',
    desc: '苹果手机看片首选，适配iPhone全系列，流畅度高、省电优化，看片不断线。',
    img: 'https://readdy.ai/api/search-image?query=An%20iPhone%20showing%20a%20video%20player%20app%20interface%20with%20film%20posters%20and%20play%20button%2C%20clean%20modern%20design%2C%20placed%20on%20a%20minimal%20desk%20setup%20with%20warm%20ambient%20light%2C%20editorial%20tech%20product%20photography&width=800&height=500&seq=card-ios-02&orientation=landscape',
    tag: '苹果专属',
  },
  {
    title: '91免费看片 Windows 版',
    desc: '电脑端专用播放器，支持4K/8K解码，多窗口同时播放，办公娱乐两不误。',
    img: 'https://readdy.ai/api/search-image?query=A%20laptop%20screen%20showing%20a%20media%20player%20interface%20with%20video%20thumbnails%20and%20playlist%2C%20minimal%20workspace%20setup%20with%20keyboard%20and%20mouse%2C%20soft%20natural%20lighting%2C%20clean%20modern%20desk%20aesthetic%2C%20warm%20tones&width=800&height=500&seq=card-windows-03&orientation=landscape',
    tag: '电脑端',
  },
  {
    title: '91免费软件合集包',
    desc: '涵盖播放器、下载器、格式转换等多款免费工具，一站配齐看片所需软件。',
    img: 'https://readdy.ai/api/search-image?query=A%20collection%20of%20app%20icons%20and%20software%20boxes%20arranged%20neatly%20on%20a%20light%20surface%2C%20featuring%20media%20player%20and%20video%20related%20tools%2C%20minimal%20flat%20lay%20style%2C%20warm%20cream%20background%2C%20soft%20shadow%2C%20professional%20product%20photography&width=800&height=500&seq=card-bundle-04&orientation=landscape',
    tag: '合集推荐',
  },
  {
    title: '91免费看片 Mac 客户端',
    desc: 'macOS原生适配，支持M系列芯片优化，低功耗高性能，Mac用户看片神器。',
    img: 'https://readdy.ai/api/search-image?query=A%20MacBook%20displaying%20a%20modern%20video%20streaming%20application%20with%20film%20library%20and%20player%20controls%2C%20placed%20on%20a%20wooden%20desk%20with%20coffee%20cup%2C%20warm%20natural%20light%20from%20window%2C%20cozy%20home%20office%20setting&width=800&height=500&seq=card-mac-05&orientation=landscape',
    tag: 'Mac专属',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">推荐应用</h2>
          <p className="mt-2 text-sm text-foreground-500">各平台91免费看片软件与客户端下载</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardsData.slice(0, 3).map((card, i) => (
            <a key={i} href="#app" className="group rounded-xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all cursor-pointer">
              <div className="aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <div className="flex items-start justify-between gap-3">
                  <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">{card.title}</h3>
                  <span className="flex-shrink-0 text-[10px] px-2 py-0.5 bg-accent-100 text-accent-800 rounded-full font-medium">{card.tag}</span>
                </div>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed">{card.desc}</p>
              </div>
            </a>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {cardsData.slice(3).map((card, i) => (
            <a key={i + 3} href="#app" className="group rounded-xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all cursor-pointer flex flex-col sm:flex-row">
              <div className="sm:w-48 flex-shrink-0 aspect-[16/10] sm:aspect-auto overflow-hidden bg-background-100">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 flex flex-col justify-center">
                <div className="flex items-start justify-between gap-3">
                  <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">{card.title}</h3>
                  <span className="flex-shrink-0 text-[10px] px-2 py-0.5 bg-accent-100 text-accent-800 rounded-full font-medium">{card.tag}</span>
                </div>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed">{card.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}